const getRange = (
  pageNumber: number,
  pageCount: number,
  fullPager: boolean
) => {
  let start = Math.max(1, pageNumber - 1);
  let end = Math.min(pageNumber + 1, pageCount);

  if (pageNumber - 1 <= 1) {
    end = Math.min(pageCount, 3);
  }

  if (pageCount - pageNumber <= 1) {
    start = Math.max(1, pageCount - 2);
  }

  if (!fullPager) {
    start = 1;
    end = pageCount;
  }

  let result: number[] = [];
  for (let i = start; i <= end; i += 1) {
    result = [...result, i];
  }

  return result;
};

export const calculateRange = (
  pageNumber: number,
  pageSize: number,
  totalCount: number
) => {
  if (totalCount === 0) {
    return { prev: 1, next: 1, range: [1], pageCount: 1 };
  }

  const pageCount = totalCount === 0 ? 1 : Math.ceil(totalCount / pageSize);

  const fullPager = pageCount > 7;

  const range = getRange(pageNumber, pageCount, fullPager);

  return {
    hasFirstPage: fullPager && range[0] !== 1,
    hasLastPage: fullPager && range[range.length - 1] !== pageCount,

    jumpPrevPage:
      fullPager && pageNumber - 1 >= 2 && pageNumber !== 3
        ? Math.max(1, pageNumber - 3)
        : null,

    jumpNextPage:
      fullPager && pageCount - pageNumber >= 2 && pageNumber !== pageCount - 2
        ? Math.min(pageCount, pageNumber + 3)
        : null,

    prev: Math.max(pageNumber - 1, 1),
    range,
    next: Math.min(pageNumber + 1, pageCount),

    pageCount,
  };
};
